import { render } from "./TagBoxV3.vue?vue&type=template&id=31ba9d40&scoped=true"
import script from "./TagBoxV3.vue?vue&type=script&lang=js"
export * from "./TagBoxV3.vue?vue&type=script&lang=js"

import "./TagBoxV3.vue?vue&type=style&index=0&id=31ba9d40&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31ba9d40"],['__file',"src/containers/popup/components/TagBoxV3.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "31ba9d40"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('31ba9d40', __exports__)) {
    api.reload('31ba9d40', __exports__)
  }
  
  module.hot.accept("./TagBoxV3.vue?vue&type=template&id=31ba9d40&scoped=true", () => {
    api.rerender('31ba9d40', render)
  })

}


export default __exports__